import React from 'react'
import classNames from 'classnames'
import styles from './style.module.scss'

export interface IUserBoxMenuProps {
  userName: string
  imageUrl?: string
  email?: string
}

export const UserBoxMenu: React.FunctionComponent<IUserBoxMenuProps> = ({
  userName,
  imageUrl,
  email,
  children
}) => (
  <span>
    <span className={styles.triangle} />
    <div className={styles.menuTop}>
      <div
        className={classNames(styles.menuPhotoPlaceholder, styles.menuPhoto)}
        style={{
          backgroundImage: imageUrl ? `url(${imageUrl})` : ''
        }}
      />
      <div className={styles.menuContent}>
        <span className={styles.menuName}>{userName}</span>
        <span className={styles.menuEmail}>{email}</span>
      </div>
    </div>
    <div>{children}</div>
  </span>
)
